export const orderStatusTranslation = status => {
  const labels = {
    PENDING: "Oczekujące na płatność",
    PROCESSING: "Przetwarzanie",
    ON_HOLD: "Wstrzymane",
    COMPLETED: "Zrealizowane",
    CANCELLED: "Anulowane",
    REFUNDED: "Zwrócone",
    FAILED: "Nieudane",
  }

  if (labels?.[status]) return labels[status]

  return status
}
